var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2599 14.3V18.86L10.2599 18.4999V15.4999L10.2599 14.3ZM12.5399 13.16V20H9.11991V13.16H12.5399Z",
    fill: "currentColor",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.13999 14.8699V18.8599L1.13999 18.4999V16.4999L1.13999 14.8699ZM3.41996 13.7299V19.9999H0V13.7299H3.41996Z",
    fill: "currentColor",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3798 6.88962V18.8595L19.3798 18.5001V12.0001L19.3798 6.88962ZM21.6597 5.74963V19.9995H18.2398V5.74963H21.6597Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69996 11.4502V18.8601L5.69996 15.0001L5.69996 11.4502ZM7.97993 10.3102V20.0001H4.55997V10.3102H7.97993Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8198 12.0201V18.86L14.8198 14.0002L14.8198 12.0201ZM17.0998 10.8801V20H13.6798V10.8801H17.0998Z",
    fill: "currentColor",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1462 1.2529L18.8787 1.01458L20.9079 3.52039L21.1462 1.2529Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.926054 11.3252L0.213909 10.435L6.22937 5.62266L10.7972 8.47756L20.1735 1.30743L20.866 2.21299L10.8625 9.86271L6.31047 7.01767L0.926054 11.3252ZM11.132 8.68678L10.4836 8.71735L10.7972 8.47756L11.132 8.68678Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.a53ca0499054a996f79ecb4314e2967b.svg";
export { ForwardRef as ReactComponent };